export function deletePath(id: number) {
  return `<div id="YesNo"><a href="" onclick="event.preventDefault(); ">NO</a><a href="${id}/delete">YES</a></div>`;
}
